// Variants
import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const SUCCESS_LINK_PROPS = {
  action: 'NAVIGATION',
  target: 'BLANK',
  type: VARIANTS.LinkVariantType.PRIMARY,
};

export { SUCCESS_LINK_PROPS };
